<!--新闻舆情-->
<template>
  <div class="popularFeelings">
    <div ref="news0" class="first-content" style="padding: 0px 0px 20px;">
      <div class="title-min SourceHanSansCN">新闻舆情<span class="quota">{{ tablePage.total }}</span></div>
      <div style="padding: 0px 0px 20px;" v-if="newsPublicOpinion.length>0">
        <div v-for="newsPublic in newsPublicOpinion" class="popular-content"
             @click="newsPublicOpinionDetails(newsPublic.id)">
          <el-row style="padding: 0px 30px;">
            <el-col :span="24" class="popular-title">{{ newsPublic.title }}</el-col>
            <el-col :span="24" class="popular-con">{{ newsPublic.brief }}</el-col>
            <el-col :span="24" class="popular-con">发布时间：{{ newsPublic.time }}</el-col>
          </el-row>
        </div>
        <!--分页-->
        <div style="padding:10px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
      <div class="none-content" v-else>暂无数据</div>
    </div>
  </div>
</template>
<script>
import page from "@/components/page/page";
import {corporateNewsList} from '@/api/enterpriseDetailsApi'
export default {
  name: "popularFeelings",
  components:{page},
  data() {
    return {
      newsPublicOpinion: [],
      height_min: document.documentElement.clientHeight,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    /*新闻舆情*/
    getCorporateNewsList() {
      corporateNewsList({cid: this.corpId, request: 'form', page: this.tablePage.currentPage}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.newsPublicOpinion = res.content.ccJournalismList;
          this.tablePage.total=res.content.totalNum;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getCorporateNewsList();
    },
    /*新闻舆情详情*/
    newsPublicOpinionDetails(id) {
      this.$router.push({path: '/enterpriseDetails/textDetails?id=' + id + '&cid=' + this.corpId});
    },
  },
  mounted() {
    this.getCorporateNewsList();
  }
}
</script>

<style lang="scss" scoped>
.popularFeelings {
  .first-content {
    background: white;

    .popular-content {
      padding: 20px 0px;
      border-bottom: 1px solid #E4ECF5;

      .popular-title {
        font-size: 16px;
        color: #222222
      }

      .popular-con {
        color: #555555;
        font-size: 14px;
        padding-top: 10px;
      }
    }

    .title-min {
      padding: 20px 30px;
      font-size: 16px;
      font-weight: bold;
      color: #222222;
    }
  }

  .none-content {
    margin: 10px 30px 20px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid #EEEEEE;
    background: #ffffff;
  }
}
</style>